import { AxiosInstance } from 'axios';

import * as common from '../../../../../../typings/api/skymap/rest/v0/.common';
import * as types from '../../../../../../typings/api/skymap/rest/v0/geodata';

export class GeodataService implements types.Handlers {
  private serviceEndpoint = '/geodata';

  constructor(private axios: AxiosInstance) {}
  async optimize(params: types.OptimizeParameters): Promise<types.OptimizeResponse> {
    return (
      await this.axios.post(
        `${this.serviceEndpoint}/${params.path.geodataId}/optimize`,
        params.body,
      )
    ).data;
  }

  async fetchGeodataById(
    params: types.FetchGeodataByIdParameters,
  ): Promise<types.GetGeodataResponse> {
    return (await this.axios.get(`${this.serviceEndpoint}/${params.path.geodataId}`)).data;
  }
  async deleteGeodata(params: types.DeleteGeodataParameters): Promise<void> {
    return (
      await this.axios.delete(`${this.serviceEndpoint}/${params.path.geodataId}`, {
        headers: {
          ...params.headers,
        },
      })
    ).data;
  }
  async pushGcpCorrectionJob({
    path,
    body,
  }: types.PushGcpCorrectionJobParameters): Promise<common.MessageOnlyResponse> {
    return (await this.axios.post(`${this.serviceEndpoint}/${path.geodataId}/gcp-job`, body)).data;
  }
  async fetchGcpCorrectionJob({
    path,
  }: types.FetchGcpCorrectionJobParameters): Promise<types.GcpCorrectionJobResponse> {
    return (await this.axios.get(`${this.serviceEndpoint}/${path.geodataId}/gcp-job`)).data;
  }
  transferGeodataToProject(
    params: types.TransferGeodataToProjectParameters,
  ): Promise<common.MessageOnlyResponse> {
    throw new Error('Method not implemented.');
  }
  async createGeodata({
    body,
  }: types.CreateGeodataParameters): Promise<types.CreateGeodataResponse> {
    return (await this.axios.post(`${this.serviceEndpoint}`, body)).data;
  }
  async fetchOrthophotoURL(
    params: types.FetchOrthophotoURLParameters,
  ): Promise<common.DownloadURLResponse> {
    return (await this.axios.get(`${this.serviceEndpoint}/${params.path.geodataId}/orthophoto`))
      .data;
  }
  async fetchLasURL(params: types.FetchLasURLParameters): Promise<common.DownloadURLResponse> {
    return (await this.axios.get(`${this.serviceEndpoint}/${params.path.geodataId}/las`)).data;
  }
  async fetchLazUrl(params: types.FetchLazUrlParameters): Promise<common.DownloadURLResponse> {
    return (await this.axios.get(`${this.serviceEndpoint}/${params.path.geodataId}/laz`)).data;
  }
  async fetchCesiumURL(
    params: types.FetchCesiumURLParameters,
  ): Promise<common.DownloadURLResponse> {
    return (await this.axios.get(`${this.serviceEndpoint}/${params.path.geodataId}/cesium`)).data;
  }
  async fetchScanURL(params: types.FetchScanURLParameters): Promise<common.DownloadURLResponse> {
    return (await this.axios.get(`${this.serviceEndpoint}/${params.path.geodataId}/scan`)).data;
  }
  async fetchObjUrl(params: types.FetchObjUrlParameters): Promise<common.DownloadURLResponse> {
    return (await this.axios.get(`${this.serviceEndpoint}/${params.path.geodataId}/obj`)).data;
  }
  async fetchDxfTerrainModelUrl(
    params: types.FetchDxfTerrainModelUrlParameters,
  ): Promise<common.DownloadURLResponse> {
    return (await this.axios.get(`${this.serviceEndpoint}/${params.path.geodataId}/terrain-dxf`))
      .data;
  }
  async fetchReportURL(
    params: types.FetchReportURLParameters,
  ): Promise<common.DownloadURLResponse> {
    return (await this.axios.get(`${this.serviceEndpoint}/${params.path.geodataId}/report`)).data;
  }
  async fetchTifURL(params: types.FetchTifURLParameters): Promise<common.DownloadURLResponse> {
    return (
      await this.axios.get(`${this.serviceEndpoint}/${params.path.geodataId}/tif`, {
        params: params.query,
      })
    ).data;
  }
  async fetchWebpUrl(params: types.FetchWebpUrlParameters): Promise<common.DownloadURLResponse> {
    return (await this.axios.get(`${this.serviceEndpoint}/${params.path.geodataId}/webp`)).data;
  }
  async fetchWebpWorldUrl(
    params: types.FetchWebpWorldUrlParameters,
  ): Promise<common.DownloadURLResponse> {
    return (await this.axios.get(`${this.serviceEndpoint}/${params.path.geodataId}/webp-world`))
      .data;
  }
  async fetchTfwUrl(params: types.FetchTfwUrlParameters): Promise<common.DownloadURLResponse> {
    return (
      await this.axios.get(`${this.serviceEndpoint}/${params.path.geodataId}/tfw`, {
        params: params.query,
      })
    ).data;
  }
  async fetchAgisoftProjectURL(
    params: types.FetchAgisoftProjectURLParameters,
  ): Promise<common.DownloadURLResponse> {
    return (await this.axios.get(`${this.serviceEndpoint}/${params.path.geodataId}/agisoftproject`))
      .data;
  }
  async fetchPhotosZIPURL(
    params: types.FetchPhotosZIPURLParameters,
  ): Promise<common.DownloadURLResponse> {
    return (await this.axios.get(`${this.serviceEndpoint}/${params.path.geodataId}/photoszip`))
      .data;
  }
  async fetchXMLURL(params: types.FetchXMLURLParameters): Promise<common.DownloadURLResponse> {
    return (await this.axios.get(`${this.serviceEndpoint}/${params.path.geodataId}/xml`)).data;
  }
  async saveXml(params: types.SaveXmlParameters): Promise<void> {
    return (
      await this.axios.put(`${this.serviceEndpoint}/${params.path.geodataId}/xml`, params.body)
    ).data;
  }
  async fetchPhotos(params: types.FetchPhotosParameters): Promise<types.GetPhotosResponse> {
    return (
      await this.axios.get(`${this.serviceEndpoint}/${params.path.geodataId}/photos`, {
        params: params.query,
      })
    ).data;
  }
  async generate(params: types.GenerateParameters): Promise<void> {
    return (await this.axios.post(`${this.serviceEndpoint}/${params.path.geodataId}/generate`))
      .data;
  }

  async fetchJobs(params: types.FetchJobsParameters): Promise<types.FetchJobsResponse> {
    return (await this.axios.get(`${this.serviceEndpoint}/jobs`)).data;
  }

  async getFilteredPointCloudUrl(
    params: types.GetFilteredPointCloudUrlParameters,
  ): Promise<common.DownloadURLResponse> {
    return (
      await this.axios.get(`${this.serviceEndpoint}/${params.path.geodataId}/filtered-point-cloud`)
    ).data;
  }

  async getCoordinateSystem(
    params: types.GetCoordinateSystemParameters,
  ): Promise<types.CoordinateSystemResponse> {
    return (
      await this.axios.get(`${this.serviceEndpoint}/${params.path.geodataId}/coordinate-system`)
    ).data;
  }

  async getSignedRequestParameters(
    params: types.GetSignedRequestParametersParameters,
  ): Promise<common.SignedRequestResponse> {
    return (await this.axios.get(`${this.serviceEndpoint}/${params.path.geodataId}/signed-request`))
      .data;
  }

  async createPendingGeodata({
    body,
  }: types.CreatePendingGeodataParameters): Promise<types.CreateGeodataResponse> {
    return (await this.axios.post(`${this.serviceEndpoint}/pending`, body)).data;
  }
}
